export const changeRouteKeepParams = (
  currentPath: string,
  newPath: string,
  preservedParams?: string[]
): string => {
  const queries = getQueryParams(currentPath);
  const queriesForNewPath = getQueryParams(newPath);
  const hash = getHash(newPath);

  // preserve old queries
  queries.forEach((value, key) => {
    if (!queriesForNewPath.has(key) && (!preservedParams || preservedParams?.includes(key))) {
      queriesForNewPath.append(key, value);
    }
  });

  let indexOfQueryOrHash = newPath.indexOf("?");
  if (indexOfQueryOrHash === -1) {
    indexOfQueryOrHash = newPath.indexOf("#");
  }
  const baseNewPath = indexOfQueryOrHash >= 0 ? newPath.substring(0, indexOfQueryOrHash) : newPath;

  const paramsStr = queriesForNewPath.toString() !== "" ? `?${queriesForNewPath.toString()}` : "";

  return `${baseNewPath}${paramsStr}${hash || ""}`;
};

export const getQueryParams = (path: string) => {
  const hasQueriesIndex = path.indexOf("?");
  const hasHashIndex = path.indexOf("#");

  const hasHash =
    hasHashIndex >= 0
      ? path.substring(hasQueriesIndex, hasHashIndex)
      : path.substring(hasQueriesIndex);

  const searchQuery = hasQueriesIndex >= 0 ? hasHash : "";

  const params = new URLSearchParams(searchQuery);

  return params;
};

function getHash(path: string) {
  const index = path.indexOf("#");

  if (index === -1) {
    return null;
  }

  // Also at the end so get everything
  return path.substring(index);
}
